/**
 * status_markdown-Parser (client.md §9.1). Grammatik: Split an `^## `-Überschriften.
 * Referenz: example/03-pioniere/solution/pioneers1/files/agent_status.md
 */

export type ParsedBudget = { total?: number; used?: number; checksum?: string };

export type ParsedAgent = {
  name: string;
  state?: string;
  iteration?: number;
  tokens?: number;
  updated?: string;
  note?: string;
};

export type HistoryEntry = { ts: string; text: string };

export type ParsedStatus = {
  budget?: ParsedBudget;
  agents: ParsedAgent[];
  history: HistoryEntry[];
};

function parseKeyValueBlock(body: string): Record<string, string> {
  const out: Record<string, string> = {};
  for (const line of body.split("\n")) {
    const m = line.match(/^\s*([a-zA-Z_]+):\s*(.*)$/);
    if (m) out[m[1]] = m[2].trim();
  }
  return out;
}

export function parseStatusMarkdown(markdown: string): ParsedStatus {
  const result: ParsedStatus = { agents: [], history: [] };
  if (!markdown) return result;

  const blocks = markdown.split(/^##\s+/m).slice(1); // erstes Element vor der ersten Überschrift verwerfen
  for (const block of blocks) {
    const newlineIdx = block.indexOf("\n");
    const header = (newlineIdx === -1 ? block : block.slice(0, newlineIdx)).trim();
    const body = newlineIdx === -1 ? "" : block.slice(newlineIdx + 1);

    if (header === "budget") {
      const kv = parseKeyValueBlock(body);
      result.budget = {
        total: kv.total !== undefined ? Number(kv.total) : undefined,
        used: kv.used !== undefined ? Number(kv.used) : undefined,
        checksum: kv.checksum,
      };
    } else if (header.startsWith("agent ")) {
      const name = header.slice("agent ".length).trim();
      const kv = parseKeyValueBlock(body);
      result.agents.push({
        name,
        state: kv.state,
        iteration: kv.iteration !== undefined ? Number(kv.iteration) : undefined,
        tokens: kv.tokens !== undefined ? Number(kv.tokens) : undefined,
        updated: kv.updated,
        note: kv.note,
      });
    } else if (header === "history") {
      for (const line of body.split("\n")) {
        const m = line.match(/^\s*-\s+(\S+)\s+(.*)$/);
        if (m) result.history.push({ ts: m[1], text: m[2] });
      }
    }
  }
  return result;
}

/** Erkennt Muster aus §9.1 für Feed-Karten; unbekannte Zeilen bleiben "generic". */
export type HistoryKind =
  | "created"
  | "started"
  | "stopped-done"
  | "stopped-budget"
  | "stopped-blocked"
  | "voucher"
  | "generic";

export function classifyHistoryLine(text: string): HistoryKind {
  if (/workspace created/i.test(text)) return "created";
  if (/started/i.test(text)) return "started";
  if (/stopped:\s*done/i.test(text)) return "stopped-done";
  if (/stopped:\s*budget-exhausted/i.test(text)) return "stopped-budget";
  if (/stopped:\s*blocked/i.test(text)) return "stopped-blocked";
  if (/voucher\s*\+\d+/i.test(text)) return "voucher";
  return "generic";
}
